const about = {
	init() {
		new Swiper('.swiper', {
			slidesPerView: 1.1,
			spaceBetween: 16,
			breakpoints: {
				768: {
					slidesPerView: 3.25,
					spaceBetween: 40
				}
			},
		});
	}
}

about.init();
